module.exports = __webpack_public_path__ + "static/media/ribbon.80aadc46.png";